import View from './View';
import svg from 'url:../../img/icons.svg';

class ResultsView extends View {
  _parentElement = document.querySelector('.results');
  _errorMsg = `No recipe found for the searched query!`;
  _Msg = `Start by searching for a recipe or an ingredient. Have fun!`;

  _generateMarkup() {
    // console.log(this._data.key);
    let id = window.location.hash.slice(1);
    return this._data
      .map(el => {
        return `
    <li class="preview">
    <a class="preview__link ${
      el.id === id ? 'preview__link--active' : ''
    }" href="#${el.id}">
      <figure class="preview__fig">
        <img src="${el.imageUrl}" alt="${el.title}" />
      </figure>
      <div class="preview__data">
        <h4 class="preview__title">${el.title}...</h4>
        <p class="preview__publisher">${el.publisher}</p>
        
        <div class="preview__user-generated ${el.key ? '' : 'hidden'}">
                <svg>
                  <use href="${svg}#icon-user"></use>
                </svg>
              </div>
      </div>
    </a>
  </li>
      `;
      })
      .join('');
  }
}
export default new ResultsView();
